module.exports = __webpack_public_path__ + "../resources/img/storebadge_de.3ea40ccd.png";